<template>
  <div class="container">
    <MemberNav id="member-nav"></MemberNav>
    <router-view id="change-view"></router-view>
    <MemberLogin v-if="false" id="member-login"></MemberLogin>
  </div>
</template>

<script>
import MemberNav from "@/components/member/member_nav.vue";
import MemberLogin from "@/views/member/member_login.vue";

export default {
  name: "member",
  components: {
    MemberNav,
    MemberLogin
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.container {
  display: flex;
  flex-wrap: nowrap;
  padding: 140px 70px 60px 70px;
  @include betweenPhoneTable {
    flex-wrap: wrap;
    padding: 140px 15px;
  }
}
#member-nav {
  flex: 0 0 23.3%;
  min-width: 147px;
  margin-right: 2.8%;
  @include betweenPhoneTable {
    flex: 1 0 auto;
    min-width: 303px;
    margin-right: 0;
  }
  @include phone {
    min-width: 273px;
  }
}
#change-view {
  min-height: calc(100vh - 377px);
  flex: 1 0 auto;
  @include phone {
    flex: 1 0 273px;
  }
}
#member-login {
  margin: 0 auto;
}
</style>
